import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Dottnetdevelopment/Hero";
import DevelopServices from "../components/Dottnetdevelopment/DevelopServices";
import Technology from "../components/Dottnetdevelopment/Technology";
import Process from "../components/Dottnetdevelopment/Process";
import IndustryBussinessjs from "../components/Dottnetdevelopment/IndustryBussinessjs";
import Commitment from "../components/Dottnetdevelopment/Commitment";
import Customers from "../components/Dottnetdevelopment/Customers";
import Success from "../components/Dottnetdevelopment/Success";
import PageTitle from "../components/Dottnetdevelopment/PageTitle";

import '../assets/Webdevelopment.css';



const Dottnetdevelopment = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<Technology />
	    	<Process />
	    	<IndustryBussinessjs />
	    	<Commitment />
	    	<Customers/>
	    	<Success />
	  </div>
	)
}

export default Dottnetdevelopment;
